module.exports = __webpack_public_path__ + "static/img/cb_case.e846981.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cb_case.jpg
// module id = Ipb3
// module chunks = 1